<template>
  <div class="home antialiased font-sans  flex flex-col h-full">
    <!-- <PromoBanner v-if="showPromoBanner" @close="closePromoBanner" /> -->
    <Topbar v-if="hasLoaded" @showOnboarding="showOnboardingModal = true" />
    <router-view v-if="hasLoaded"></router-view>
    <div class="text-center flex flex-col h-full justify-center" v-else>
      <h1
        class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight"
      >
        Welcome to Carthike
      </h1>
    </div>
    <OnboardingVideoModal v-if="showOnboardingModal" @close="onModalClose" />
    <!-- <ReviewModal
      :value="totalRecoveredValue"
      v-if="showReviewModal"
      @close="showReviewModal = false"
    /> -->
  </div>
</template>

<script>
// import Spinner from "vue-simple-spinner";
import { differenceInDays } from "date-fns";
// @ is an alias to /src
import Topbar from "@/components/Common/Topbar.vue";
// import PromoBanner from "@/components/Common/PromoBanner.vue";

import OnboardingVideoModal from "@/components/Common/OnboardingVideoModal";
// import ReviewModal from "@/components/Common/ReviewModal";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

export default {
  name: "Home",
  components: {
    Topbar,
    OnboardingVideoModal,
    // Spinner
    // ReviewModal,
    // PromoBanner
  },
  data() {
    return {
      showOnboardingModal: false,
      showReviewModal: false,
      totalRecoveredValue: 0,
      showPromoBanner: false,
      hasLoaded: false
    };
  },
  async created() {
    const authToken = this.$route.query.token;
    const existingToken = window.localStorage.getItem("authToken");
    if (authToken) {
      window.localStorage.setItem("authToken", authToken);
    } else {
      const tokenFromUrl = this.getTokenFromUrl();
      if (tokenFromUrl) {
        window.localStorage.setItem("authToken", tokenFromUrl);
      } else if (!existingToken) {
        this.$router.push({ name: "Login" });
        return;
      }
    }
    this.setMessagesListener();
    const response = await this.$store.dispatch("getConfig");
    this.hasLoaded = true;
    const store = response.store;
    const route = this.$route.path;
    console.log("route", route);
    this.setEmailOnCrisp();
    this.showPromo();

    if (store && store.isPlanSelected) {
      if (route === "/") {
        this.$router.push({ name: "Carts" });
        return;
      }
    }

    if (store && store.isPlanSelected === false) {
      this.$router.push({ name: "Plan" });
    }

    if (store.hasReviewed === false && this.notShownOnLast7days()) {
      const recoveredValueResponse = await this.$store.dispatch(
        "getTotalRecoveredValue"
      );
      if (
        recoveredValueResponse &&
        recoveredValueResponse.totalRecoveredValue &&
        recoveredValueResponse.totalRecoveredValue > 0
      ) {
        console.log("show review popup", { recoveredValueResponse });
        this.totalRecoveredValue = `${recoveredValueResponse.currency} ${recoveredValueResponse.totalRecoveredValue}`;
        this.showReviewModal = true;
      }
    }
  },
  methods: {
    onModalClose() {
      this.showOnboardingModal = false;
    },
    getLastReviewModalShownTime() {
      const time = window.localStorage.getItem("lastReviewModalShownTime");
      return time;
    },
    notShownOnLast7days() {
      const time = this.getLastReviewModalShownTime();
      if (!time) {
        return true;
      }
      const diffDate = differenceInDays(new Date(), new Date(parseInt(time)));
      if (diffDate > 7) {
        return true;
      }
      return false;
    },
    checkForOnboarding() {
      const config = this.$store.getters.getConfig;
      if (
        config &&
        config.createdAt > 1652433630 &&
        config.hasCompletedOnboarding === false
      ) {
        this.$router.push({ name: "Onboarding" });
      }
    },
    parseJwt(token) {
      var base64Payload = token.split(".")[1];
      var payload = Buffer.from(base64Payload, "base64");
      return JSON.parse(payload.toString());
    },
    setEmailOnCrisp() {
      const token = window.localStorage.getItem("authToken");
      if (token) {
        const payload = this.parseJwt(token);
        // eslint-disable-next-line
        if (payload && payload.email && $crisp) {
          $crisp.push(["set", "user:email", [payload.email]]); // eslint-disable-line
          const store = this.$store.getters.getStore;
          const shopifyPlan = this.$store.getters.getShopifyPlan;
          // eslint-disable-next-line
          $crisp.push([
            "set",
            "session:data",
            [
              [
                ["plan", store.plan],
                ["hasReviewed", store.hasReviewed],
                ["manualMessageSent", store.manualMessageSent],
                ["shopOrigin", store.shopOrigin],
                [
                  "sendMessagesUsingDesktopApp",
                  store.sendMessagesUsingDesktopApp
                ],
                ["storeId", store.id],
                ["shopifyPlan", shopifyPlan]
              ]
            ]
          ]);
        }
      }
    },
    showPromo() {
      const item = window.localStorage.getItem("showInstaPromoBanner");
      if (item === null) {
        this.showPromoBanner = true;
      }
    },
    closePromoBanner() {
      window.localStorage.setItem("showInstaPromoBanner", false);
      this.showPromoBanner = false;
    },
    getTokenFromUrl() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });
      return params.token;
    },
    async setMessagesListener() {
      try {
        const isMessagingSupported = await isSupported();
        if (isMessagingSupported) {
          const messaging = getMessaging();
          onMessage(messaging, payload => {
            console.log("Message received. ", payload);
            const currentRoute = this.$route;
            if (
              currentRoute.name !== "TeamInboxChat" ||
              (currentRoute.name == "TeamInboxChat" &&
                currentRoute.params.conversationId !=
                  payload.data.conversationId)
            ) {
              var notification = new Notification(payload.data.title, {
                body: payload.data.body,
                data: { conversationId: payload.data.conversationId }
              });
              notification.onclick = event => {
                console.log("notification event", event);
                const target = event.target.data;
                this.$router.push({
                  name: "TeamInboxChat",
                  params: { conversationId: target.conversationId }
                });
              };
            }
            // ...
          });
        }
      } catch (error) {
        console.log("error while setting notifications");
      }
    }
  }
};
</script>
